module.exports = __webpack_public_path__ + "img/R16.57204e62.png";